import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

const customSpacingKeys = [
  'control', 'control-sm', 'control-compact',
  'layout-sm', 'layout-md', 'layout-lg', 'layout-xl',
  'layout-2xl', 'layout-3xl', 'layout-4xl', 'layout-5xl',
] as const

const customRadiusKeys = ['field', 'control', 'card'] as const

const customFontSizeKeys = [
  'micro', 'overline', 'data',
  'display', 'h1', 'h2', 'h3', 'title', 'body', 'body-sm', 'caption',
] as const

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      spacing: customSpacingKeys,
      radius: customRadiusKeys,
      text: customFontSizeKeys,
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getProductType(tradeParam: string): [string, string] {
  const parts = tradeParam.split('-')
  if (parts.length < 2) {
    return ['', '']
  }

  const trade = parts[0]
  const productSlug = parts.slice(1).join('-')

  return [trade, productSlug]
}
